/* Políticas legales HerBalance — generado por paginas-v2/construir_shopify.py.
   Toma el texto legal que pinta Shopify (.shopify-policy__container) y lo ordena en el diseño: encabezado, pestañas,
   índice que sigue la lectura y caja de dudas. NO cambia el texto: solo lo mueve y le da estructura (en Términos, los
   títulos «SECCIÓN N» en negrita pasan a subtítulos y cada salto de línea a un párrafo). Si algo falla, queda la versión de Shopify. */
(() => {
  const cont = document.querySelector('.shopify-policy__container');
  const datosEl = document.getElementById('ova-politicas');
  if (!cont || !datosEl || document.getElementById('ova2')) return;
  let datos;
  try { datos = JSON.parse(datosEl.textContent); } catch (e) { return; }

  const CORTOS = { 'refund-policy': 'Devoluciones', 'privacy-policy': 'Privacidad', 'terms-of-service': 'Términos', 'shipping-policy': 'Envíos', 'contact-information': 'Datos de la empresa', 'subscription-policy': 'Suscripción', 'legal-notice': 'Aviso legal' };
  const SOBRE = { 'refund-policy': 'la política de devoluciones', 'privacy-policy': 'la política de privacidad', 'terms-of-service': 'los términos del servicio', 'shipping-policy': 'los envíos', 'contact-information': 'los datos de la empresa' };
  const clave = u => (u.split('/policies/')[1] || '').replace(/\/$/, '');
  const actual = clave(location.pathname);
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const ico = (n, relleno) => `<svg class="ico${relleno ? ' relleno' : ''}" aria-hidden="true"><use href="#i-${n}"/></svg>`;
  const slug = t => t.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').split('-').slice(0, 7).join('-');

  try {
    const rte = cont.querySelector('.shopify-policy__body .rte') || cont.querySelector('.shopify-policy__body');
    let titulo = (cont.querySelector('.shopify-policy__title h1') || {}).textContent || document.title;
    titulo = titulo.trim();

    // Contenido: si viene envuelto en un solo <div>, se desenvuelve.
    // Se trabaja sobre una copia: si algo falla antes del final, la página de Shopify queda intacta.
    let nodos = [...rte.cloneNode(true).childNodes];
    const elementos = nodos.filter(n => n.nodeType === 1);
    if (elementos.length === 1 && elementos[0].tagName === 'DIV') nodos = [...elementos[0].childNodes];
    const prosa = document.createElement('div');
    prosa.className = 'prosa';
    nodos.forEach(n => prosa.appendChild(n));

    // Si el texto trae su propio <h1> al inicio (Devoluciones), ese es el título y sale del cuerpo.
    const primero = [...prosa.children][0];
    if (primero && primero.tagName === 'H1') { titulo = primero.textContent.trim(); primero.remove(); }
    // El resto de <h1> dentro del texto bajan a <h2>.
    prosa.querySelectorAll('h1').forEach(h => { const h2 = document.createElement('h2'); h2.innerHTML = h.innerHTML; h.replaceWith(h2); });

    // Términos: un solo párrafo con títulos en negrita y <br>. Se parte en subtítulos y párrafos sin tocar el texto.
    const RE_TIT = /^(DESCRIPCI[ÓO]N GENERAL|SECCI[ÓO]N\s*\d+\s*[:.].*)$/i;
    [...prosa.querySelectorAll('p')].forEach(p => {
      const titulos = [...p.querySelectorAll(':scope > strong, :scope > b')].filter(s => RE_TIT.test(s.textContent.trim()));
      if (titulos.length < 2) return;
      const frag = document.createDocumentFragment();
      let actualP = document.createElement('p');
      let brs = 0;
      const cerrar = () => {
        // quita <br> y espacios sueltos al inicio y al final del párrafo
        while (actualP.firstChild && (actualP.firstChild.nodeName === 'BR' || (actualP.firstChild.nodeType === 3 && !actualP.firstChild.textContent.trim()))) actualP.firstChild.remove();
        while (actualP.lastChild && (actualP.lastChild.nodeName === 'BR' || (actualP.lastChild.nodeType === 3 && !actualP.lastChild.textContent.trim()))) actualP.lastChild.remove();
        if (actualP.childNodes.length) frag.appendChild(actualP);
        actualP = document.createElement('p');
      };
      [...p.childNodes].forEach(n => {
        if (titulos.includes(n)) {
          cerrar();
          const h2 = document.createElement('h2');
          const t = n.textContent.trim();
          const m = t.match(/^(SECCI[ÓO]N\s*\d+\s*[:.])\s*(.*)$/i);
          if (m) h2.innerHTML = `<span class="pol-n">${esc(m[1])}</span> ${esc(m[2])}`; else h2.textContent = t;
          const lim = m ? m[2] : t;
          h2.dataset.indice = (m ? m[1].replace(/\D+/g, '') + '. ' : '') + lim.charAt(0) + lim.slice(1).toLowerCase();
          frag.appendChild(h2);
          brs = 0;
          return;
        }
        // Cada salto de línea del texto de Shopify es un párrafo nuevo (el texto no cambia).
        if (n.nodeName === 'BR') { cerrar(); brs = 0; return; }
        if (n.nodeType === 3 && !n.textContent.trim()) { actualP.appendChild(n); return; }
        brs = 0;
        actualP.appendChild(n);
      });
      cerrar();
      p.replaceWith(frag);
    });

    // Anclas e índice
    const h2s = [...prosa.querySelectorAll('h2')];
    h2s.forEach((h, i) => {
      if (!h.id) h.id = slug(h.textContent) || 'parte-' + (i + 1);
      h.dataset.etiqueta = h.dataset.indice || h.textContent.trim().replace(/\s+/g, ' ');
      const a = document.createElement('a');
      a.className = 'pol-ancla'; a.href = '#' + h.id; a.setAttribute('aria-label', 'Enlace a esta sección'); a.textContent = '#';
      h.append(a);
    });

    const palabras = prosa.textContent.trim().split(/\s+/).length;
    const nombre = CORTOS[actual] || titulo;
    const partes = titulo.split(/\s+—\s+/);
    const tituloHtml = partes.length > 1 ? `${esc(partes[0])} <small>— ${esc(partes.slice(1).join(' — '))}</small>` : esc(titulo);
    const ORDEN = ['refund-policy', 'privacy-policy', 'terms-of-service', 'shipping-policy', 'contact-information'];
    const pos = u => { const i = ORDEN.indexOf(clave(u)); return i < 0 ? 99 : i; };
    const pestanas = (datos.politicas || []).slice().sort((a, b) => pos(a.url) - pos(b.url)).map(p => {
      const k = clave(p.url);
      return `<a href="${esc(p.url)}"${k === actual ? ' aria-current="page"' : ''}>${esc(CORTOS[k] || p.titulo)}</a>`;
    }).join('');
    const wa = `https://wa.me/${datos.whatsapp}?text=${encodeURIComponent(`Hola, tengo una pregunta sobre ${SOBRE[actual] || 'las políticas'} de HerBalance.`)}`;
    const corto = actual === 'refund-policy' ? `
      <aside class="pol-corto degradado-claro" aria-label="En corto">
        <span class="ceja">En corto</span>
        <div class="pol-corto-enlaces">
          <a class="pol-corto-enlace" href="${esc(datos.garantia)}"><span class="pol-ico-c">${ico('escudo')}</span><span><b>Lee la explicación en simple de la garantía</b><small>Las condiciones de los 90 días y un calendario con tus fechas.</small></span>${ico('chev-der').replace('class="ico"', 'class="ico pol-ir"')}</a>
          <a class="pol-corto-enlace" href="${esc(datos.contacto)}"><span class="pol-ico-c">${ico('chat')}</span><span><b>¿Tu caso es distinto? Escríbenos</b><small>Te ayudamos por WhatsApp o por correo.</small></span>${ico('chev-der').replace('class="ico"', 'class="ico pol-ir"')}</a>
        </div>
      </aside>` : '';

    const raiz = document.createElement('div');
    raiz.className = 'ova2 ova-pg pol';
    raiz.id = 'ova2';
    raiz.innerHTML = `
      <section class="pol-cab degradado-firma" id="arriba">
        <span class="halo pol-halo" aria-hidden="true"></span>
        <div class="contenedor pol-cab-grid">
          <nav class="migas" aria-label="Estás en"><a href="/">Inicio</a><span aria-hidden="true">/</span><span>Políticas</span><span aria-hidden="true">/</span><span>${esc(nombre)}</span></nav>
          <span class="ceja">Legal</span>
          <h1 class="t-1 pol-titulo">${tituloHtml}</h1>
          <div class="pol-meta">
            <p class="pol-lectura">${ico('reloj')}<span>Lectura de ${Math.max(1, Math.round(palabras / 200))} min</span></p>
            <button class="btn btn-borde btn-sm pol-imprimir" type="button" id="pol-imprimir">${ico('descarga')}Imprimir / guardar PDF</button>
          </div>
          <p class="pol-impreso">${esc(location.host + location.pathname)}</p>
        </div>
        ${pestanas ? `<div class="contenedor"><nav class="pol-tabs" aria-label="Políticas de la tienda">${pestanas}</nav></div>` : ''}
      </section>
      <div class="contenedor pol-cuerpo" id="politica">
        <aside class="pol-indice" id="pol-indice" aria-label="En esta página"><p class="pol-indice-tit">En esta página</p><ol class="pol-indice-lista"></ol></aside>
        <div class="pol-principal">
          <details class="pol-indice-movil" id="pol-indice-movil"><summary><span class="pol-im-tit">En esta página</span><span class="pol-im-actual" id="pol-im-actual"></span></summary><ol class="pol-indice-lista"></ol></details>
          ${corto}
          <article class="pol-doc" id="doc"></article>
          <section class="pol-dudas degradado-claro">
            <div class="pol-dudas-txt"><h2 class="t-3">¿Dudas sobre esta política?</h2><p>Escríbenos y te ayudamos a entender cómo aplica a tu caso.</p></div>
            <div class="pol-dudas-acciones">
              <a class="btn btn-naranja" href="${wa}" target="_blank" rel="noopener">${ico('wa', true)}Escribir por WhatsApp</a>
              <a class="pol-correo" href="mailto:${esc(datos.correo)}">${ico('correo')}<span><small>o al correo</small><b>${esc(datos.correo)}</b></span></a>
              <p class="pol-solo-impresion">WhatsApp: +57 311 438 0133 · Correo: ${esc(datos.correo)}</p>
            </div>
          </section>
        </div>
      </div>`;
    raiz.querySelector('#doc').appendChild(prosa);
    if (h2s.length < 2) { raiz.querySelector('#pol-indice').remove(); raiz.querySelector('#pol-indice-movil').remove(); raiz.querySelector('.pol-cuerpo').classList.add('sin-indice'); }
    cont.replaceWith(raiz);
    document.documentElement.classList.add('ova-pol-lista');

    // Índice (PC y celular) y apartado actual
    const listas = [...raiz.querySelectorAll('ol.pol-indice-lista')];
    listas.forEach(ol => { ol.innerHTML = h2s.map(h => `<li><a href="#${h.id}"></a></li>`).join(''); [...ol.querySelectorAll('a')].forEach((a, i) => { a.textContent = h2s[i].dataset.etiqueta; }); });
    const indicePc = raiz.querySelector('#pol-indice');
    const movil = raiz.querySelector('#pol-indice-movil');
    const actualMovil = raiz.querySelector('#pol-im-actual');
    let ultimo = -1;
    const marcar = () => {
      if (!h2s.length) return;
      const tope = Math.min(160, innerHeight * .3);
      let i = 0;
      h2s.forEach((h, j) => { if (h.getBoundingClientRect().top <= tope) i = j; });
      if (i === ultimo) return;
      ultimo = i;
      listas.forEach(ol => ol.querySelectorAll('a').forEach((a, j) => { a.classList.toggle('activo', j === i); if (j === i) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current'); }));
      if (actualMovil) actualMovil.textContent = h2s[i].dataset.etiqueta;
      const a = indicePc && indicePc.querySelectorAll('a')[i];
      if (a && indicePc.scrollHeight > indicePc.clientHeight) {
        const arriba = a.offsetTop, abajo = arriba + a.offsetHeight;
        if (arriba < indicePc.scrollTop + 40 || abajo > indicePc.scrollTop + indicePc.clientHeight - 40) indicePc.scrollTop = arriba - indicePc.clientHeight / 2;
      }
    };
    const medir = () => { if (!indicePc) return; indicePc.classList.toggle('desborda', indicePc.scrollHeight > indicePc.clientHeight + 2); indicePc.classList.toggle('al-final', indicePc.scrollTop + indicePc.clientHeight >= indicePc.scrollHeight - 2); };
    if (indicePc) indicePc.addEventListener('scroll', medir, { passive: true });
    let raf = 0;
    addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(marcar); }, { passive: true });
    addEventListener('resize', () => { ultimo = -1; marcar(); medir(); });
    listas.forEach(ol => ol.addEventListener('click', e => { if (e.target.closest('a') && movil) movil.open = false; }));
    document.addEventListener('click', e => { if (movil && movil.open && !movil.contains(e.target)) movil.open = false; });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && movil && movil.open) { movil.open = false; movil.querySelector('summary').focus(); } });
    const imp = raiz.querySelector('#pol-imprimir');
    if (imp) imp.addEventListener('click', () => window.print());
    // Pestaña elegida visible en celular
    const tabs = raiz.querySelector('.pol-tabs');
    const elegida = tabs && tabs.querySelector('[aria-current="page"]');
    if (elegida && tabs.scrollWidth > tabs.clientWidth) tabs.scrollLeft = elegida.offsetLeft - (tabs.clientWidth - elegida.offsetWidth) / 2;
    marcar(); medir();
    // Si se llegó con #ancla, ir a ella ahora que existe.
    if (location.hash) { const d = document.getElementById(decodeURIComponent(location.hash.slice(1))); if (d) d.scrollIntoView(); }
  } catch (e) {
    // Ante cualquier error, se deja la página de Shopify tal cual.
    if (window.console) console.warn('Políticas HerBalance:', e);
  }
})();
